import React from "react";
import { usePermissions } from "../hooks/usePermissions";

const ConditionalRender = ({
  requiredPermissions,
  children,
  fallback = null,
}) => {
  const { canAccess } = usePermissions();

  if (!canAccess(requiredPermissions)) {
    return fallback;
  }

  return children;
};

// Ajouter une propriété pour identifier le composant de manière fiable
ConditionalRender.$$typeof = Symbol.for('ConditionalRender');
ConditionalRender.displayName = 'ConditionalRender';

export default ConditionalRender;
